import { tenantSubdomain } from '../tenant/tenantSubdomain';

export default class AuthCurrentTenant {
  static selectAndSaveOnStorageFor(currentUser: any) {
    if (!currentUser) {
      return null;
    }

    if (!currentUser.tenants) {
      return null;
    }

    const activeTenants = currentUser.tenants.filter(
      (tenantUser: any) => tenantUser.status === 'active',
    );

    if (!activeTenants || !activeTenants.length) {
      return null;
    }

    const storedTenantId = this.get();
    const firstTenantId = activeTenants[0].tenant.id;
    let tenant;

    if (storedTenantId) {
      tenant = activeTenants
        .map((tenantUser: any) => tenantUser.tenant)
        .find((tenant: any) => tenant.id === storedTenantId);
    }

    // Check for admin override flag from backend (new approach)
    const backendAdminFlag = currentUser.adminChangedDefaultWorkspace;
    // Check for admin override flag in sessionStorage (legacy approach)
    const sessionAdminFlag = sessionStorage.getItem(`adminChangedWorkspace_${currentUser.id}`);

    if (backendAdminFlag || sessionAdminFlag) {
      // Admin specifically changed this user's default - override their preference
      console.log('Admin override detected - switching to first tenant:', activeTenants[0].tenant.name);

      // Clear both flags
      if (sessionAdminFlag) {
        sessionStorage.removeItem(`adminChangedWorkspace_${currentUser.id}`);
      }

      // If backend flag is set, we need to clear it via API call
      if (backendAdminFlag) {
        this.clearAdminWorkspaceOverride();
      }

      this.clear();
      tenant = activeTenants[0].tenant;
    } else if (!tenant) {
      // No stored tenant or invalid stored tenant, use first
      tenant = activeTenants[0].tenant;
    }
    // If tenant exists and no admin override, keep the user's choice

    if (
      tenant &&
      tenantSubdomain.isEnabled &&
      !tenantSubdomain.isSubdomainOf(tenant.url)
    ) {
      return tenantSubdomain.redirectAuthenticatedTo(
        tenant.url,
      );
    }

    this.set(tenant);
    return tenant;
  }

  static get() {
    const tenantASString =
      localStorage.getItem('tenant') || null;

    if (tenantASString) {
      return JSON.parse(tenantASString).id;
    }

    return null;
  }

  static getSettings() {
    const tenantASString =
      localStorage.getItem('tenant') || null;

    if (tenantASString) {
      const tenant = JSON.parse(tenantASString);

      if (tenant) {
        if (Array.isArray(tenant.settings)) {
          if (tenant.settings.length) {
            return tenant.settings[0];
          }
        } else {
          return tenant.settings;
        }
      }
    }

    return null;
  }

  static set(tenant: any) {
    if (!tenant) {
      return this.clear();
    }

    localStorage.setItem('tenant', JSON.stringify(tenant));
  }

  static clear() {
    localStorage.removeItem('tenant');
  }

  static async clearAdminWorkspaceOverride() {
    try {
      // Import AuthService dynamically to avoid circular dependency
      const AuthService = (await import('./authService')).default;
      await AuthService.clearWorkspaceOverride();
    } catch (error) {
      console.error('Failed to clear admin workspace override:', error);
    }
  }
}
